import KreisePosts from './KreisePosts';

export default KreisePosts;
